import { EspecialDos } from '../../models/especial-dos';
import { EspecialDosService } from '../../services/especial-dos.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  Validators,
  UntypedFormGroup,
  FormGroup,
} from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ConfiguracionIndicadoresService } from 'src/app/modulos/elementos-plan/services/configuracion-indicadores.service';

@Component({
  selector: 'app-especial-dos',
  templateUrl: './especial-dos.component.html',
  styleUrls: ['./especial-dos.component.css'],
})
export class EspecialDosComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: 'Administración Sistema' },
    { label: 'Catálogos Proceso' },
    { label: 'Especial Dos', active: true },
  ];

  public mostrarModal: boolean = false;
  public dataViewTable!: any;
  public formEspecialDos!: UntypedFormGroup;
  public formSelectCatalogo!: FormGroup;
  public submitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataApp: any[] = [];
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public nameUnidad!: any;
  fathers: any = [];
  publicpp!: any;

  selectedOptionRecursivo: any = null;
  filtroPost = ''; //para la clase filtro
  public nombrePadre: string = null; //para validacion de catalogo
  public nameModal: string = 'modalNewEdit';
  nameApp = 'CATÁLOGO ESPECIAL DOS';

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;

  constructor(
    private fb: FormBuilder,
    private especialDosService: EspecialDosService,
    private alert: AlertService,
    private ip: IpPublicService,
    private configIndicadorService: ConfiguracionIndicadoresService,
    public modal: ModalService
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  get rolForm() {
    return this.formEspecialDos.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.listDataApp();
    this.formEspecialDos = this.fb.group({
      idSprEspecialDos: [],
      spr_idSprEspecialDos: [],
      nombrePadre: [], // nombre de la validacion de un padre
      nombre: ['', [Validators.required]],
      descripcion: [],
      formula: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
    this.formSelectCatalogo = this.fb.group({
      spr_idSprEspecialDos: [0],
    });
  }

  initApp() {
    this.listDataApp();
    this.setDataTable();
    this.setForm();
  }
  ngOnInit(): void {
    this.getIpPublic();
    this.initApp();
   
  }
  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSubmit() {
    this.submitted = true;
    this.formEspecialDos.value.usuario = this.currentUser.idSprUsuario;
    this.formEspecialDos.value.ip = this.ipAddress;
    this.formEspecialDos.value.nombre = this.formEspecialDos.value.nombre
      .trim()
      .toUpperCase();
    this.selectedOptionRecursivo =
      this.formEspecialDos.value.spr_idSprEspecialDos;

    if (this.formEspecialDos.value.idSprEspecialDos == null) {
       //if (this.listEspecialDosExisteDiferente(this.formEspecialDos.value.nombre, this.formEspecialDos.value.idSprEspecialDos)){
        this.especialDosService.create(this.formEspecialDos.value).subscribe(
          (resp) => {
            this.initApp();
            this.modal.close();
            this.alert.createOk();
          },
          (err) => {
            this.alert.createError();
          }
        );
      //}
    } else {
      //if (this.listEspecialDosExisteDiferente(this.formEspecialDos.value.nombre, this.formEspecialDos.value.idSprEspecialDos)) {
      this.especialDosService.update(this.formEspecialDos.value).subscribe(
        (resp) => {
          this.initApp();
          this.modal.close();
          this.alert.updateOk();
        },
        (err) => {
          this.alert.updateError();
        }
      );
    //}
    }
  }


  // listEspecialDosExiste(nombre: any) {
  //   let nombresInicio = nombre.trimStart();
  //   let nombresFin = nombresInicio.trimEnd();
  //   for (let elemento of this.dataApp) {
  //     if (elemento.nombre == nombresFin) {
  //       this.alert.warning('¡Atención!',"Existe un catálogo especial dos con el mismo nombre");
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  listEspecialDosExisteDiferente(nombre: any, idSprEspecialDos: any) {
    let vector: any = [];
    let vectorFiltrado: any = [];

    // para que no se repita los nombres
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    vector = this.dataApp;
    for (let elemento of vector) {
      if (elemento.idSprEspecialDos !== idSprEspecialDos) {
        vectorFiltrado.push(elemento);
      }
    }
    for (let elemento of vectorFiltrado) {
      if (elemento.nombre == nombresFin) {
        this.alert.warning('¡Atención!',"Existe un catálogo especial dos con el mismo nombre");
        return false;
      }
    }
    return true;
  }


  edit(obj: EspecialDos) {
    this.openModal();
    this.formEspecialDos.patchValue({
      idSprEspecialDos: obj.idSprEspecialDos,
      spr_idSprEspecialDos: obj.spr_idSprEspecialDos,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      formula: obj.formula,
      estado: obj.estado,
    });
  }

  delete(idRegister: number) {
    this.modal.open('delete-especialDos');
    //this.initApp();
    this.idDeleteRegister = idRegister;
  }

  verifyUnidadMedida() {
    return this.configIndicadorService
      .list(`?idSprUnidadMedida=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }
  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyUnidadMedida();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';

    if (confirmDelete) {
      if (this.getParent(this.idDeleteRegister)) {
        this.especialDosService
          .delete({
            idSprEspecialDos: this.idDeleteRegister,
            usuario: this.currentUser.idSprUsuario,
            delLog: 'S',
            ip: this.ipAddress,
          })
          .subscribe({
            next: (resp) => {
              this.selectedOptionRecursivo=null;
              this.initApp();
              this.modal.close();
              this.alert.deleteOk();

              this.submitted = false;
            },
            error: (err) => {
              this.alert.deleteError();
            },
          });
      } else {
        this.alert.EliminarRegistroCatalogo();
      }
    }
  }

  listCatalogoExiste(nombre: any) {
    // para que no se repita los nombres
    for (let elemento of this.dataApp) {
      if (elemento.nombre == nombre) {
        this.alert.RepetirNombre();
        return false;
      }
    }
    return true;
  }
  getParent(id: number) {
    // validacion para que no se pueda eliminar un padre con hijos
    for (let elemento of this.dataApp) {
      if (elemento.spr_idSprEspecialDos == id) {
        this.alert.EliminarRegistroCatalogo();
        this.modal.closeId('delete-especialDos');
        return false;
      }
    }
    return true;
  }
  listDataApp() {
    this.especialDosService.list().subscribe((resp) => {
      this.dataApp = resp;
      this.getDataDependiente(this.selectedOptionRecursivo);
      //this.reDrawDataTable();
      //this.dataApp = resp;
    });
    return true;
  }

  cargarCatalogoDependiente(a: any) {
    this.selectedOptionRecursivo = a.value;
    this.nombrePadre = a[a['options'].selectedIndex].text;
    if (this.selectedOptionRecursivo > 0) {
      this.getDataDependiente(this.selectedOptionRecursivo);
    } else {
      this.dataViewTable = this.fathers;
    }
  }

  getDataDependiente(spr_idSprEspecialDos: any = null) {
    let stateOptionTipo = false;
    let father = 'N/A';
    let dataAllProcesar = this.dataApp;
    let dependientes: any = [];
    dataAllProcesar.forEach((row: any) => {
      if (!stateOptionTipo && spr_idSprEspecialDos != null) {
        father = row.idSprEspecialDos == spr_idSprEspecialDos ? row.nombre : '';
        if (father != '') {
          stateOptionTipo = true;
        }
      }
      if (row.spr_idSprEspecialDos == spr_idSprEspecialDos) {
        dependientes.push({
          idSprEspecialDos: row.idSprEspecialDos,
          nombre: row.nombre,
          descripcion: row.descripcion,
          formula: row.formula,
          spr_idSprEspecialDos: row.spr_idSprEspecialDos,
          estado: row.estado,
          tipo: father,
        });
      }
    });
    if (spr_idSprEspecialDos == null || spr_idSprEspecialDos == 0) {
      this.dataViewTable = dependientes;
      this.fathers = dependientes;
    } else {
      this.dataViewTable = dependientes;
    }
  }

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
    if (
      this.selectedOptionRecursivo == 0 ||
      this.selectedOptionRecursivo == null
    ) {
      this.nombrePadre = null;
    }
    this.formEspecialDos.patchValue({
      spr_idSprEspecialDos: this.selectedOptionRecursivo,
      nombrePadre: this.nombrePadre,
      formula: '', // formula en 0
    });
  }

  onResetForm() {
    this.submitted = false;
    this.formEspecialDos.reset();
  }
}
